import { getProjectInstallationById } from '@api/services/project-installation.service';
import useDataQuery from '@hooks/use-data-query';

const useProjectInstallationData = (clientInstallationId: string, projectInstallationId: string) => {
    const projectInstallationQuery = useDataQuery(
        ['project-installation', clientInstallationId, projectInstallationId],
        () => getProjectInstallationById(clientInstallationId, projectInstallationId),
        {
            enabled: Boolean(clientInstallationId && projectInstallationId),
        }
    );

    return {
        isLoading: projectInstallationQuery.isLoading,
        projectInstallation: projectInstallationQuery.data,
        setData: projectInstallationQuery.setData,
    };
};

export default useProjectInstallationData;
